import { isBaseProperty, isImmutableProperty, isRequiredProperty } from './mfsProperty';

import { mfsError } from '../errors';

/**
 * Returns the property key for the given property name if access type is allowed.
 *
 * @param name The name of the property.
 * @param accessType The type of access, whether the property will be just read or written.
 * @returns The full property name, if the specified access type is allowed for the given property `name`.
 * @throws Access Error, when access type is not allowed for the given property (based on the property kind, whether
 *   it's system or base or app property).
 */
export function getPropertyKey(name: string, accessType: 'set' | 'delete'): string {
  if (isBaseProperty(name)) {
    if (
      (isImmutableProperty(name) && (accessType === 'set' || accessType === 'delete')) ||
      (isRequiredProperty(name) && accessType === 'delete')
    ) {
      throw mfsError.accessDenied(accessType, name);
    }
  }
  return name;
}
